namespace GeniuzPOS.InitialData {
    export interface PsPriceOverrideReasonRow {
        Id?: number;
        PriceOverrideId?: number;
        PriceOverrideReason?: string;
        Remark?: string;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        IsActive?: number;
    }

    export namespace PsPriceOverrideReasonRow {
        export const idProperty = 'PriceOverrideId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'PriceOverrideReason';
        export const localTextPrefix = 'InitialData.PsPriceOverrideReason';
        export const lookupKey = 'InitialData.PsPriceOverrideReason';

        export function getLookup(): Q.Lookup<PsPriceOverrideReasonRow> {
            return Q.getLookup<PsPriceOverrideReasonRow>('InitialData.PsPriceOverrideReason');
        }
        export const deletePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:PriceOverride:Modify';
        export const insertPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:PriceOverride:Modify';
        export const readPermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:PriceOverride:View';
        export const updatePermission = '1POSBASE:ข้อมูลอ้างอิง:การจัดการจุดขาย:PriceOverride:Modify';

        export declare const enum Fields {
            Id = "Id",
            PriceOverrideId = "PriceOverrideId",
            PriceOverrideReason = "PriceOverrideReason",
            Remark = "Remark",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            IsActive = "IsActive"
        }
    }
}
